import { render, staticRenderFns } from "./TokenLink.vue?vue&type=template&id=20ecfcb0&scoped=true&"
import script from "./TokenLink.vue?vue&type=script&lang=js&"
export * from "./TokenLink.vue?vue&type=script&lang=js&"
import style0 from "./TokenLink.vue?vue&type=style&index=0&id=20ecfcb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ecfcb0",
  null
  
)

export default component.exports